import * as constants from './actions';

const initialState = {
    message: [],
    topic: []
};

const preservedFields = [
    'address',
    'day',
    'email',
    'firstName',
    'fullName',
    'homeAddress',
    'homeCity',
    'lastName',
    'message',
    'middleName',
    'month',
    'phone',
    'postalCode',
    'prefix',
    'stateId',
    'suffix',
    'topic',
    'unit',
    'year'
];

export default function cacheFormData(state = initialState, { type, payload }) {
    switch (type) {
        case constants.CACHE_FORM_DATA:
            const matchedKeys =
                Object.keys(payload.values || {})
                    .filter(f => preservedFields.includes(f))
                    .reduce((obj, key) => {
                        if (key === 'topic' || key === 'message') {
                            const existingTopicIndex = state.topic
                                .map(e => e.actionIdentifier)
                                .indexOf(payload.actionIdentifier);

                            if (existingTopicIndex === -1) {
                                obj[key] = state.topic.concat({
                                    title: payload.values[key],
                                    actionIdentifier: payload.actionIdentifier
                                });
                            } else {
                                state.topic[existingTopicIndex] = {
                                    title: payload.values[key],
                                    actionIdentifier: payload.actionIdentifier
                                };
                            }
                        } else {
                            obj[key] = payload.values[key];
                        }
                        return obj;
                    }, {}) || {};
            return {
                ...state,
                ...matchedKeys
            };
        default:
            return state;
    }
}
